"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IGO50SceneNames {
}
IGO50SceneNames.GameList = "IGO50GameListScene";
IGO50SceneNames.Pause = "IGO50PauseScene";
IGO50SceneNames.CutScene = "IGO50CutScene";
exports.default = IGO50SceneNames;
